

export const frontMatter = {
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/numbers_1-10.html'
};
export const contentTitle = 'Броевите 1-10 на словенските јазици';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-mk-docusaurus-plugin-content-docs-current-learn-misc-numbers-1-10-md-b7c.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Природни словенски јазици",
  "id": "природни-словенски-јазици",
  "level": 2
}, {
  "value": "Конструирани словенски помошни јазици",
  "id": "конструирани-словенски-помошни-јазици",
  "level": 2
}, {
  "value": "Измислени севернословенски јазици",
  "id": "измислени-севернословенски-јазици",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    h2: "h2",
    header: "header",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "броевите-1-10-на-словенските-јазици",
        children: "Броевите 1-10 на словенските јазици"
      })
    }), "\n", _jsx(_components.h2, {
      id: "природни-словенски-јазици",
      children: "Природни словенски јазици"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Јазик"
          }), _jsx(_components.th, {
            children: "1"
          }), _jsx(_components.th, {
            children: "2"
          }), _jsx(_components.th, {
            children: "3"
          }), _jsx(_components.th, {
            children: "4"
          }), _jsx(_components.th, {
            children: "5"
          }), _jsx(_components.th, {
            children: "6"
          }), _jsx(_components.th, {
            children: "7"
          }), _jsx(_components.th, {
            children: "8"
          }), _jsx(_components.th, {
            children: "9"
          }), _jsx(_components.th, {
            children: "10"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "прасловенски"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "dŭva"
          }), _jsx(_components.td, {
            children: "трие"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "старословенски"
          }), _jsx(_components.td, {
            children: "ѥдынъ"
          }), _jsx(_components.td, {
            children: "пилана"
          }), _jsx(_components.td, {
            children: "триѥ"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "pѧt"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девојка"
          }), _jsx(_components.td, {
            children: "дескт"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Стар Новгородски"
          }), _jsx(_components.td, {
            children: "еден пилана"
          }), _jsx(_components.td, {
            children: "три (ѥ)"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "pѧt"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девојка"
          }), _jsx(_components.td, {
            children: "дескт"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Стар руски"
          }), _jsx(_components.td, {
            children: "еден пилана"
          }), _jsx(_components.td, {
            children: "триѥ"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "pѧt"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девојка"
          }), _jsx(_components.td, {
            children: "дескт"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Руски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Белоруски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Подлач"
          }), _jsx(_components.td, {
            children: "один"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "обидете се"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "јас сум"
          }), _jsx(_components.td, {
            children: "по воздушен пат"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "украински"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "SIM"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Русин"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "на сите"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Хутсул"
          }), _jsx(_components.td, {
            children: "Оден"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "şterǐ"
          }), _jsx(_components.td, {
            children: "pǐechǐ"
          }), _jsx(_components.td, {
            children: "шиschǐ"
          }), _jsx(_components.td, {
            children: "SIM"
          }), _jsx(_components.td, {
            children: "visim"
          }), _jsx(_components.td, {
            children: "deawichǐ"
          }), _jsx(_components.td, {
            children: "deasichǐ"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Лемко-Русин"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "иглички, иглички"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "чеша"
          }), _jsx(_components.td, {
            children: "SIM"
          }), _jsx(_components.td, {
            children: "осум, осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Шлезиски"
          }), _jsx(_components.td, {
            children: "само"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "pjyńć"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "од седум"
          }), _jsx(_components.td, {
            children: "uoźym"
          }), _jsx(_components.td, {
            children: "dźewjyńć"
          }), _jsx(_components.td, {
            children: "dźeśyńć"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Англиски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Кашубиски"
          }), _jsx(_components.td, {
            children: "једен"
          }), _jsx(_components.td, {
            children: "dwa"
          }), _jsx(_components.td, {
            children: "разбуди се"
          }), _jsx(_components.td, {
            children: "sztre"
          }), _jsx(_components.td, {
            children: "пиак"
          }), _jsx(_components.td, {
            children: "szesc"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "дури ни"
          }), _jsx(_components.td, {
            children: "dzewiãc"
          }), _jsx(_components.td, {
            children: "dzesãc"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Полабиски"
          }), _jsx(_components.td, {
            children: "чао"
          }), _jsx(_components.td, {
            children: "глуви"
          }), _jsx(_components.td, {
            children: "солза"
          }), _jsx(_components.td, {
            children: "цитираат"
          }), _jsx(_components.td, {
            children: "на"
          }), _jsx(_components.td, {
            children: "последно"
          }), _jsx(_components.td, {
            children: "sidĕm"
          }), _jsx(_components.td, {
            children: "visĕm"
          }), _jsx(_components.td, {
            children: "divāt"
          }), _jsx(_components.td, {
            children: "диста"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "долнолужички"
          }), _jsx(_components.td, {
            children: "јаден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "tśi"
          }), _jsx(_components.td, {
            children: "стири"
          }), _jsx(_components.td, {
            children: "pěś"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седим"
          }), _jsx(_components.td, {
            children: "осмиот"
          }), _jsx(_components.td, {
            children: "јееее"
          }), _jsx(_components.td, {
            children: "ти си"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "горнолужички"
          }), _jsx(_components.td, {
            children: "само"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "се пече"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "сидом"
          }), _jsx(_components.td, {
            children: "wosom"
          }), _jsx(_components.td, {
            children: "dźewjeć"
          }), _jsx(_components.td, {
            children: "dźesać"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "чешки"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словачки"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словенечки"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Кајкавски хрватски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Чакавски хрватски"
          }), _jsx(_components.td, {
            children: "жени"
          }), _jsx(_components.td, {
            children: "должност"
          }), _jsx(_components.td, {
            children: "тара"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седан"
          }), _jsx(_components.td, {
            children: "ošan"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "хрватски/босански"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Српски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Macedonian"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Бугарски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Русенорск"
          }), _jsx(_components.td, {
            children: "один"
          }), _jsx(_components.td, {
            children: "тва"
          }), _jsx(_components.td, {
            children: "три шетери"
          }), _jsx(_components.td, {
            children: "pjôet"
          }), _jsx(_components.td, {
            children: "сест"
          }), _jsx(_components.td, {
            children: "sêм"
          }), _jsx(_components.td, {
            children: "Vôsom"
          }), _jsx(_components.td, {
            children: "богати"
          }), _jsx(_components.td, {
            children: "недостаток"
          }), _jsx(_components.td, {})]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "конструирани-словенски-помошни-јазици",
      children: "Конструирани словенски помошни јазици"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Јазик"
          }), _jsx(_components.th, {
            children: "1"
          }), _jsx(_components.th, {
            children: "2"
          }), _jsx(_components.th, {
            children: "3"
          }), _jsx(_components.th, {
            children: "4"
          }), _jsx(_components.th, {
            children: "5"
          }), _jsx(_components.th, {
            children: "6"
          }), _jsx(_components.th, {
            children: "7"
          }), _jsx(_components.th, {
            children: "8"
          }), _jsx(_components.th, {
            children: "9"
          }), _jsx(_components.th, {
            children: "10"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Руски јазик (Крижаниќ)"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Сесловенски јазик (Бан)"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "pjat"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Vsjeslovianskyь (Бамбас)"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "диевјат"
          }), _jsx(_components.td, {
            children: "дијат"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Uzajemni Pravopis Slavjanski (Majar)"
          }), _jsx(_components.td, {
            children: "једен"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "трі"
          }), _jsx(_components.td, {
            children: "четірі"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седм"
          }), _jsx(_components.td, {
            children: "осм"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Нојславиш (Хошек)"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "pjat"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Обчесловјански (Хошек)"
          }), _jsx(_components.td, {
            children: "один"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "sixj"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Славина (Финале)"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "tre"
          }), _jsx(_components.td, {
            children: "црна"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "словенски (Колкоп)"
          }), _jsx(_components.td, {
            children: "прво"
          }), _jsx(_components.td, {
            children: "vter"
          }), _jsx(_components.td, {
            children: "трет"
          }), _jsx(_components.td, {
            children: "четвртина"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "ſix"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "словенски (Holý)"
          }), _jsx(_components.td, {
            children: "mk"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Слован (Жидек)"
          }), _jsx(_components.td, {
            children: "една"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "хтор"
          }), _jsx(_components.td, {
            children: "пиат"
          }), _jsx(_components.td, {
            children: "шесто"
          }), _jsx(_components.td, {
            children: "содом"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "давет"
          }), _jsx(_components.td, {
            children: "dasot"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Международски јазик"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словјо, Руславск"
          }), _jsx(_components.td, {
            children: "din"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "cxtir"
          }), _jsx(_components.td, {
            children: "пиат"
          }), _jsx(_components.td, {
            children: "sxes"
          }), _jsx(_components.td, {
            children: "siem"
          }), _jsx(_components.td, {
            children: "вос"
          }), _jsx(_components.td, {
            children: "dev"
          }), _jsx(_components.td, {
            children: "des"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Зборот"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Глаголица"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Прослава"
          }), _jsx(_components.td, {
            children: "един"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четри"
          }), _jsx(_components.td, {
            children: "туп"
          }), _jsx(_components.td, {
            children: "shest"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осем"
          }), _jsx(_components.td, {
            children: "деват"
          }), _jsx(_components.td, {
            children: "desat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Panslavien"
          }), _jsx(_components.td, {
            children: "един"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "ќетири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "xest"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осем"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Меџазик (словенски јазик)"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "s'est"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словенечки"
          }), _jsx(_components.td, {
            children: "mk"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "s'tir"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "s'es"
          }), _jsx(_components.td, {
            children: "тука"
          }), _jsx(_components.td, {
            children: "оска"
          }), _jsx(_components.td, {
            children: "dev"
          }), _jsx(_components.td, {
            children: "des"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словенски"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Славенен (Noven Slovio)"
          }), _jsx(_components.td, {
            children: "един"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "cetir"
          }), _jsx(_components.td, {
            children: "затворен"
          }), _jsx(_components.td, {
            children: "xest"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осем"
          }), _jsx(_components.td, {
            children: "невент"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "словенски"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пиат"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словенски јазик"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "освен"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Новословени"
          }), _jsx(_components.td, {
            children: "сингл"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Образовни Меџусловјански"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Славјанто"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "прасловенски"
          }), _jsx(_components.td, {
            children: "единствениот"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Русанто"
          }), _jsx(_components.td, {
            children: "Один"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "cxetire"
          }), _jsx(_components.td, {
            children: "пиат"
          }), _jsx(_components.td, {
            children: "sxest"
          }), _jsx(_components.td, {
            children: "сем"
          }), _jsx(_components.td, {
            children: "сите"
          }), _jsx(_components.td, {
            children: "отстапуваат"
          }), _jsx(_components.td, {
            children: "desiat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словачки"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "dvi"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "чотири"
          }), _jsx(_components.td, {
            children: "петто"
          }), _jsx(_components.td, {
            children: "шести"
          }), _jsx(_components.td, {
            children: "седми"
          }), _jsx(_components.td, {
            children: "оседми"
          }), _jsx(_components.td, {
            children: "деветто"
          }), _jsx(_components.td, {
            children: "десетти"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Венецијански"
          }), _jsx(_components.td, {
            children: "јадење"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Новословна"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Словенска нова лингвафранка (SNL)"
          }), _jsx(_components.td, {
            children: "једен"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четер"
          }), _jsx(_components.td, {
            children: "домашно милениче"
          }), _jsx(_components.td, {
            children: "вкус"
          }), _jsx(_components.td, {
            children: "причина"
          }), _jsx(_components.td, {
            children: "глас"
          }), _jsx(_components.td, {
            children: "развој"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "измислени-севернословенски-јазици",
      children: "Измислени севернословенски јазици"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Јазик"
          }), _jsx(_components.th, {
            children: "1"
          }), _jsx(_components.th, {
            children: "2"
          }), _jsx(_components.th, {
            children: "3"
          }), _jsx(_components.th, {
            children: "4"
          }), _jsx(_components.th, {
            children: "5"
          }), _jsx(_components.th, {
            children: "6"
          }), _jsx(_components.th, {
            children: "7"
          }), _jsx(_components.th, {
            children: "8"
          }), _jsx(_components.th, {
            children: "9"
          }), _jsx(_components.th, {
            children: "10"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Северијан"
          }), _jsx(_components.td, {
            children: "iedøn"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "трии"
          }), _jsx(_components.td, {
            children: "sxøtir"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "sxest"
          }), _jsx(_components.td, {
            children: "седми"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Возгиан (Gŭor vŭozgašchai)"
          }), _jsx(_components.td, {
            children: "іђін"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "ћрі"
          }), _jsx(_components.td, {
            children: "чадир"
          }), _jsx(_components.td, {
            children: "пенћ"
          }), _jsx(_components.td, {
            children: "ќе"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "дёенћ"
          }), _jsx(_components.td, {
            children: "десно"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Нашица (стара)"
          }), _jsx(_components.td, {
            children: "edët"
          }), _jsx(_components.td, {
            children: "дева"
          }), _jsx(_components.td, {
            children: "обиди"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Насика (нова)"
          }), _jsx(_components.td, {
            children: "inu"
          }), _jsx(_components.td, {
            children: "ta"
          }), _jsx(_components.td, {
            children: "tiirä"
          }), _jsx(_components.td, {
            children: "птица"
          }), _jsx(_components.td, {
            children: "педесет"
          }), _jsx(_components.td, {
            children: "да"
          }), _jsx(_components.td, {
            children: "сеттоми"
          }), _jsx(_components.td, {
            children: "остомија"
          }), _jsx(_components.td, {
            children: "тинејџер"
          }), _jsx(_components.td, {
            children: "тесемти"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Северск"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "tre"
          }), _jsx(_components.td, {
            children: "што"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Мрезиск"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "камила"
          }), _jsx(_components.td, {
            children: "тера"
          }), _jsx(_components.td, {
            children: "шатор"
          }), _jsx(_components.td, {
            children: "пинта"
          }), _jsx(_components.td, {
            children: "шаста"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Прославен"
          }), _jsx(_components.td, {
            children: "гаден"
          }), _jsx(_components.td, {
            children: "камила"
          }), _jsx(_components.td, {
            children: "вози"
          }), _jsx(_components.td, {
            children: "шатор"
          }), _jsx(_components.td, {
            children: "половина литар"
          }), _jsx(_components.td, {
            children: "шаста"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Слависк"
          }), _jsx(_components.td, {
            children: "во неговата куќа"
          }), _jsx(_components.td, {
            children: "дева"
          }), _jsx(_components.td, {
            children: "тера"
          }), _jsx(_components.td, {
            children: "штара"
          }), _jsx(_components.td, {
            children: "половина литар"
          }), _jsx(_components.td, {
            children: "Шашта"
          }), _jsx(_components.td, {
            children: "седам"
          }), _jsx(_components.td, {
            children: "мојот стар"
          }), _jsx(_components.td, {
            children: "развој"
          }), _jsx(_components.td, {
            children: "désat"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Ијслова"
          }), _jsx(_components.td, {
            children: "jijn"
          }), _jsx(_components.td, {
            children: "dvis"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "sjöris"
          }), _jsx(_components.td, {
            children: "pjem"
          }), _jsx(_components.td, {
            children: "таа"
          }), _jsx(_components.td, {
            children: "sjödem"
          }), _jsx(_components.td, {
            children: "систем"
          }), _jsx(_components.td, {
            children: "снег разнебитување"
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Шкода"
          }), _jsx(_components.td, {
            children: "Јерино"
          }), _jsx(_components.td, {
            children: "дова"
          }), _jsx(_components.td, {
            children: "трије"
          }), _jsx(_components.td, {
            children: "t'ietiiri"
          }), _jsx(_components.td, {
            children: "мали"
          }), _jsx(_components.td, {
            children: "сајт"
          }), _jsx(_components.td, {
            children: "uosme"
          }), _jsx(_components.td, {
            children: "диевиенте"
          }), _jsx(_components.td, {
            children: "diesiente"
          }), _jsx(_components.td, {
            children: "-"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Новеградски"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "Дуа"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "петто"
          }), _jsx(_components.td, {
            children: "шесто"
          }), _jsx(_components.td, {
            children: "shenyi"
          }), _jsx(_components.td, {
            children: "осмо"
          }), _jsx(_components.td, {
            children: "деветто"
          }), _jsx(_components.td, {
            children: "да се случи"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Онегиски (Онегскои езеик)"
          }), _jsx(_components.td, {
            children: "еден"
          }), _jsx(_components.td, {
            children: "два"
          }), _jsx(_components.td, {
            children: "три"
          }), _jsx(_components.td, {
            children: "четири"
          }), _jsx(_components.td, {
            children: "пет"
          }), _jsx(_components.td, {
            children: "шест"
          }), _jsx(_components.td, {
            children: "седум"
          }), _jsx(_components.td, {
            children: "осум"
          }), _jsx(_components.td, {
            children: "девет"
          }), _jsx(_components.td, {
            children: "десет"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Ротијан (Исус Христос)"
          }), _jsx(_components.td, {
            children: "jödin"
          }), _jsx(_components.td, {
            children: "dva"
          }), _jsx(_components.td, {
            children: "Три"
          }), _jsx(_components.td, {
            children: "ššetüri"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          }), _jsx(_components.td, {
            children: "-"
          })]
        })]
      })]
    }), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

